/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyNavController', DinghyNavController);

    DinghyNavController.$inject = ['$stateParams', '$scope', '$state'];

    function DinghyNavController($stateParams, $scope, $state) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.$state = $state;
        $scope.currentObj = {};
        $scope.currentObj.name = null;

        vm.states = [['board.dinghy.event', 'askApp.dinghy.event.title'],
                    ['board.dinghy.booking', 'askApp.dinghy.bookings.title'],
                    ['board.dinghy.dinghy','askApp.dinghy.detail.title'],
                    ['board.dinghy.dinghy.new','askApp.dinghy.home.createLabel'],
                    ['board.dinghy.presence', 'askApp.dinghy.presence.title'],
                    ['board.dinghy.plan', 'askApp.dinghy.plan.title'],
                    ['board.dinghy.newsletter', 'askApp.dinghy.newsletter.title']];
    }
})();
